<template>
  <div class="home">
    <div :class="{ back: isStickys }">
      <!-- :class="{ 'back': isStickys }" -->
      <header class="sticky-header" :class="{ sticky: isSticky }">
        <img
          style="display: block;  margin-top: -8px"
          v-if="!isSticky"
          src="../../assets/changchenglogo.png"
          alt=""
        />
        <img
          style="display: block;  margin-top: -13px"
          v-if="isSticky"
          src="../../assets/changchenglogo2.png"
          alt=""
        />        
        <el-menu
          :class="{ stickymenu: isSticky }"
          :default-active="activeIndex"
          style="opacity: 1"
          class="el-menu-demo el-menu-vertical-demo"
         
          @select="handleSelect"
          background-color="transparent"
          text-color="white"
          active-text-color="white"
        
        >
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="4">产业赋能</el-menu-item>
          <el-menu-item index="2">军单贷</el-menu-item>
          <el-menu-item index="8">票易融
          </el-menu-item>
          <el-menu-item index="3">军绿贷</el-menu-item>
          
         
          <el-menu-item index="5">关于</el-menu-item>
          <!-- <el-submenu
            index="5"
            style="color: black; font-size: 20px"
            :class="{ submenutitle: isSticky }"
           
          >
            <template slot="title" >关于</template>
            <el-menu-item index="5-1">新闻公告</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-2">企业简介</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-3">联系我们</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-4">常见问题</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-4">APP</el-menu-item>
          </el-submenu> -->
          <!-- <el-menu-item index="6"><a href="https://www.ele.me" target="_blank">注册</a></el-menu-item> -->
          <el-menu-item index="6" @click="zhuceclick()">注册</el-menu-item>
          <el-menu-item index="7" @click="loginclick()">登录</el-menu-item>
          <!-- <el-menu-item index="8"><a href="https://www.ele.me" target="_blank">APP</a></el-menu-item> -->
        </el-menu>
      </header>
    </div>
    
    <div class="banner" v-if="activeIndex == ''">
      <el-carousel height="auto" :autoplay="false">
        <el-carousel-item v-for="(item, index) in bannerimg" :key="index">
          <div class="carousel-item-content">
            <img class="bannerimg" :src="item.img" alt="" />
            <!-- <div class="bannertext">
              <ul>
                <li>
                  <span class="textnum">累计访问用户</span>
                  <p class="number" style="font-size: 45px; font-weight: 500">
                    {{ currentNumber1 }}
                    <span style="font-size: 22px">人</span>
                  </p>
                </li>
                <li>
                  <span class="textnum">累计为用户融资额</span>
                  <p class="number" style="font-size: 45px">
                    {{ currentNumber2 }} <span style="font-size: 22px">万</span>
                  </p>
                </li>
                <li>
                  <span class="textnum">累计服务项目总数</span>
                  <p class="number" style="font-size: 45px">
                    {{ currentNumber3 }} <span style="font-size: 22px">个</span>
                  </p>
                </li>
                <li>
                  <span class="textnum">累计获取交易订单</span>
                  <p class="number" style="font-size: 45px">
                    {{ currentNumber4 }} <span style="font-size: 22px">单</span>
                  </p>
                </li>
              </ul>
            </div> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
   
    <content>
     
      <div class="homepage" v-if="activeIndex == ''">
        <div class="brief">
          <div style="margin: 0 auto; display: flex; position: relative">
            <img src="../../assets/x组 11.png" alt="" />
            <div class="briefdiv">
              <img
                class="comp"
                src="../../assets/PLATFORM INTRODUCTION.png"
                alt=""
              />
              <b>平台简介</b>
              <div
                style="
                  width: 20px;
                  height: 4px;
                  background-color: #ccc;
                  margin-left: 41px;
                  margin-top: 20px;
                "
              ></div>
              <p style="line-height: 30px">
                中国长城产融服务平台，是基于中国长城互联网信息安全底座，由中国长城网信息中心联合中国航天科技集团供应链协同服务中心、北京北信源软件股份有限公司、国科智造（北京）科技有限公司等单位共同打造的国防工业数字化供应链产融信息服务平台。
              </br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台重点面向各军队单位和各大军工集团所属单位及其供应 链配套企业，提供供应链金融、科技金融、产业金融等领域投融资对接，以及科技成果转化、产融数字化等综合服务。
              </p>
            </div>
          </div>
        </div>
      
        <div class="product">
          <div style="position: relative">
            <div class="proctext">
              <h1>产品展示</h1>
              <img src="../../assets/ProductDisplay.png" alt="" />
            </div>

            <div class="productbox">
              <transition name="fade" mode="out-in">
                <img
                  @click="Imgrouter(currentIndex)"
                  :src="productimgsrc"
                  :key="currentIndex"
                  class="slide-image"
                  style="z-index: 10; position: absolute"
                />
              </transition>
              <img
                src="../../assets/产品4.svg"
                alt=""
                style="
                  width: 100%;
                  height: 100%;
                  position: relative;
                  z-index: 9;
                  left: 0;
                  top: 0;
                "
              />

              <div class="blockbtn" style="position: absolute">
                <button @click="previousImage()" style="cursor: pointer">
                  <img src="../../assets/箭头.png" alt="" />
                </button>
                <button    @click="Imgclick()"  style="background-color: #ffb84e; cursor: pointer"  @mouseover="hoverImage">
                  <img
                    @mouseover="hoverImage"
                 
                    src="../../assets/箭头 (1).png"
                    alt=""
                  />
                </button>
                <!-- <button
                  v-if="flgabtn1"
                  @click="Imgclick()"
                  style="background-color: #ffb84e; cursor: pointer"
                  @mouseout="unhoverImage"
                >
                  <img
                    @mouseout="unhoverImage"
                    src="../../assets/箭头 (1).png"
                    alt=""
                  />
                </button> -->
              </div>
            </div>
          </div>
        </div>
        <div class="state">
          <div style="position: relative">
            <div class="statetext">
              <h1>最新动态</h1>
              <img
                class="stateimg"
                src="../../assets/Latest updates.png"
                alt=""
              />
            </div>
            <div class="statebox">
              <ul>
                <li v-for="item in newslist">
                  <img class="imgs" :src="item.mPicture" alt="" />
                  <h2>{{ item.noticeTitle }}</h2>
                  <span
                    >{{item.descp}}</span
                  >
                  <!-- <router-link  target="_blank" to="/aboutdetails"> -->

                  <button @click="opendetails(item)" style="cursor: pointer">
                    <img src="../../assets/箭头 (3).png" alt="" />
                  </button>
                  <!-- </router-link> -->
                </li>
                <!-- <li>
                  <img src="../../assets/组 16 (1).png" alt="" />
                  <h2>银行保险机构数据安全管理办法公开征求意见</h2>
                  <span>来源： 中国金融网  2024-03-22 19:09:20</span>
                  <button @click="opendetails()" style="cursor: pointer">
                    <img src="../../assets/箭头 (3).png" alt="" />
                  </button>
                </li>
                <li>
                  <img src="../../assets/组 16 (2).png" alt="" />
                  <h2>2023年末金融业机构总资产461.09万亿元</h2>
                  <span
                    >金融业机构负债为420.78万亿元，同比增长10.1%，其中，银行业机构负债为383.12万亿元，同比增长10.1%；证券业机构负债为10.43万亿元，同比增长5.5%；保险业机构负债为27.22万亿元，同比增长11.4%。</span
                  >
                  <button @click="opendetails()" style="cursor: pointer">
                    <img src="../../assets/箭头 (3).png" alt="" />
                  </button>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="strategic">
          <div class="strategictext">
            <h1>战略合作伙伴</h1>
            <img
              class="stateimg"
              src="../../assets/Strategic partners.png"
              alt=""
            />
          </div>

          <div class="statebox">
            <ul>
              <li>
                <img src="../../assets/容器 15.svg" alt="" />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <AboutView style="margin-top: 6%" v-if="activeIndex == '5'" />
      <Military v-if="activeIndex == '2'" />
      <MilitaryGreen v-if="activeIndex == '3'" />
      <mastery v-if="activeIndex == '4'" />
      <receipt v-if="activeIndex == '6'" />
    </content>
    <footer v-if="activeIndex == ''">
      <div style="width:800px;margin:30px auto;text-align: left;display: flex;">
        <img style="display: block;width: 88px;height: 88px;margin-top: 100px;margin-left:228px;" src="../../assets/二维码 2.png" alt="">
        <div style="margin-top: 100px;margin-left:83px;width: 2px;height: 88px;background: rgba(255, 255, 255, 0.2);"></div>
        <div style="width: 330px;margin-left: 30px;margin-top: 90px;">
            <p style=" color: white;">
            地址：北京市海淀区闵庄路3号玉泉慧谷5号楼
            </p>
            <p style="color: white">电话：010-62960259</p>
            <p style="color: white">服务邮箱：ccgyljr@ccjr.freeqiye.com</p>
        </div>
       
      </div>
      <div style="display: flex;margin: 35px auto;flex-direction: row;align-items: center;justify-content: center;">
        <p style="color:#FFEDB2;margin-left:20px;">版权所有：国科智造</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <p style="color:#FFEDB2;">ICP备案号：京ICP备2024050167号-3</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <p style="color:#FFEDB2;">京公网安备11010802046272号 </p>
      </div>
    </footer>
    <div class="contact" v-if="activeIndex == ''">
      <ul>
        <li>
          <img src="../../assets/通话.png" alt="" />
        </li>
        <li>
          <img src="../../assets/二维码.png" alt="" />
        </li>
        <li @click="scrollToTop()">
          <img src="../../assets/置底.png" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import hellow from "@/components/HelloWorld";
import AboutView from "@/components/about";
import Military from "@/components/Military"; //军单贷
import MilitaryGreen from "@/components/MilitaryGreen"; //军绿贷
import mastery from "@/components/mastery"; //专精贷
import receipt from "@/components/receipt"; //票据贷

import {noticelist,getfilepath} from '../../request/api'
export default {
  name: "home",
  data() {
    return {
      activeIndex: "",
      isSticky: false,
      isStickys: true,
      currentNumber1: 369, // 当前数值
      currentNumber2: 100, // 当前数值
      currentNumber3: 32, // 当前数值
      currentNumber4: 41, // 当前数值
      targetNumber: 100, // 目标数值
      timer: null, // 用于存储计时器
      procttext: [
        {
          name: "军单贷",
          indexss: "1",
        },
        {
          name: "军绿贷",
          indexss: "0",
        },
        {
          name: "专精特新贷",
          indexss: "0",
        },
      ],
      activeName: "first",
      flgabtn: true,
      flgabtn1: false,
      cpzsimg: require("../../assets/内容.png"),
      cpzsimgs: require("../../assets/蒙版.png"),
      bannerimg: [
        {
          img: require("../../assets/banner (1).png"),
        },
        {
          img: require("../../assets/banner.png"),
        },
      ],
      images: [
        require("../../assets/产品1.svg"),
        require("../../assets/产品2.svg"),
        require("../../assets/产品3.svg"),
      ],
      currentIndex: 0,
      newslist:[]
    };
  },
  components: {
    AboutView,
    Military,
    MilitaryGreen,
    mastery,
    receipt
  },
  mounted() {
    // window.addEventListener('resize', function () {
    //     var img = document.querySelector('.image-responsive');
    //     img.style.width = (window.innerWidth * 0.8) + 'px'; // 80% 的窗口宽度
    //     img.style.height = 'auto'; // 保持宽高比
    // });
    this.xinwen();
    this.startCountup();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    productimgsrc() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    xinwen(){
      let param = {
        noticeType: '3'
      }
            noticelist(param).then(res=>{
              if(res.code==200){
                let data = res.rows.splice(0,3);
                data.forEach(element => {
                  element.mPicture = getfilepath + element.mPicture;
                  // element.mPicture = 'http://192.168.1.50:28000/profile/' + element.mPicture;
                });
                this.newslist = data;
                console.log(this.newslist);
              }
            })
        },
    aboutclick(){
      this.activeIndex = "5";

    },
    zhuceclick() {
      this.activeIndex = "";
     
      // window.open("http://101.96.133.18:17000/#/register");
      // window.open('http://192.168.1.130:80/#/register')
      window.open('http://www.cgwcrpt.com/#/register')
    },
    loginclick() {
      this.activeIndex = "";
      // window.open("http://101.96.133.18:17000/#/login");
      // window.open('http://192.168.1.130:80/#/login')
      window.open('http://www.cgwcrpt.com/#/login')
    },
    Imgrouter(item) {
      this.isSticky = true;
      window.removeEventListener("scroll", this.handleScroll);
      if (item == "0") {
        this.activeIndex = "2";
      }
      if (item == "1") {
        this.activeIndex = "3";
      }
      if (item == "2") {
        this.activeIndex = "4";
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 可选，使滚动平滑进行
      });
    },
    opendetails(item) {
      // window.open("http://localhost:8080/#/aboutdetails");
      // window.open('http://192.168.1.130:80/#/aboutdetails')
      window.open('http://www.cgwcrpt.com/#/aboutdetails?item=' + item.noticeId)
      // window.open('http://localhost:28000/#/aboutdetails?item=' + item.noticeId)

    },
    previousImage() {
      this.currentIndex =
        this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
    },
    Imgclick() {
      this.currentIndex =
        this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0;
      console.log(this.currentIndex);
    },
    unhoverImage() {
      this.flgabtn = true; // 鼠标移出时恢复原始图片
      this.flgabtn1 = false; // 鼠标移出时恢复原始图片
    },
    hoverImage() {
      this.flgabtn = false; // 鼠标悬停时更换图片
      this.flgabtn1 = true; // 鼠标悬停时更换图片
    },
    startCountup() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.currentNumber < this.targetNumber) {
            this.currentNumber++;
          } else {
            // 达到目标数值后停止计时
            clearInterval(this.timer);
          }
        }, 50); // 每秒更新一次
      }
    },

    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.isStickys = false;
      console.log(key, keyPath);
      if (key == "5-1" || key == "5-2" || key == "5-3" || key == "5-4") {
        this.activeIndex = "5";
      }
      if (key != "1") {
        this.isSticky = true;
        window.removeEventListener("scroll", this.handleScroll);
      }
      if (key == "1") {
        this.activeIndex = "";
        this.isSticky = false;
        this.isStickys = true;
        window.addEventListener("scroll", this.handleScroll);
      }
      if(key == '8'){
        this.activeIndex = ""
        // window.open('https://rc-zslj.sxychain.com:8443/sp-inquiry');//测试
        window.open('https://htkj.sxychain.com/sp-inquiry');//正式

        
      }
      // if (this.activeIndex == '7') {
      //     // this.$router.push('/login')
      //     // window.open('http://192.168.1.130:80/#/login')
      //     window.open('http://localhost:8080/#/login')
      // }

      console.log(key, keyPath);
    },
    handleScroll() {
      this.isSticky = window.scrollY > 780;
      this.isStickys = window.scrollY < 550;
      // const header = this.$el.querySelector('.sticky-header');
      // const scrollTop = document.documentElement.scrollTop;
      // const headerHeight = header.offsetHeight;

      if (window.scrollY > 680) {
        this.isSticky = true;
        this.isStickys = false;
      }

      // if (scrollTop >= 550) {
      //     this.isSticky = true;
      //     this.isStickys = false;
      // } else {
      //     this.isStickys = false;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.slide-image {
  width: 100%;
  height: auto;
  box-shadow: none;
  transition: transform 0.1s ease;
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sticky-header {
  width: 100%;
  height: 80px;
  // background-color: rgb(84, 92, 100);
  display: flex;
  position: fixed;
  top: 0px;
  // opacity: 0.7;
//   transition: opacity ease-in-out;
  color: white;
  z-index: 999999;

  // box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
}


.sticky-header:hover {
  background-color: rgba(84, 92, 100, .1) !important;
// background-color: red;
//   opacity: 0.2;
  z-index: 99999;
  color: white;
  top: 0;
}

::v-deep .el-submenu__title .el-submenu__icon-arrow::before {
  content: none !important;
}

.sticky-header.sticky {
  // background-color: rgb(84, 92, 100);
  background-color: white;
  color: #c49958;
  display: flex;
  width: 100%;
  // position: sticky;
  top: 0;
  // opacity: 1;
  height: 73px;
  z-index: 999;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
}
.sticky-header.sticky:hover{
  background-color: white !important;
  border-bottom: none !important;
  // background-color: none !important;
  // background-color: transparent !important;
} 

::v-deep .stickymenu {
  // background-color: white;
  color: #c49958 !important;
  display: flex;
  // width: 100%;
  // position: sticky;
  top: 0px;
  opacity: 1;
  z-index: 10;

  text-align: center;
  .el-menu-item:hover {
    border-bottom: 2px solid #c49958 !important;
    // border-bottom: none !important;
  // background-color: none !important;
  // background-color: transparent !important;
    // top: -8px;
  }
  .el-menu-item {
    // background-color: white;
    color: #c49958 !important;
    display: flex;
    // width: 100%;
    // height: 60px !important;
    position: sticky;
    top: 0px;
    opacity: 1;
    z-index: 10;
    text-align: center;
  background-color: none !important;
    
  }

  .submenutitle {
    .el-submenu__title:hover {
      border-bottom: 2.5px solid #c49958 !important;
      
    }
    .el-submenu__title {
      color: #c49958 !important;
      display: flex;
      width: 100%;
      height: 71.5px !important;
      // position: sticky;
      top: 0px !important;
      opacity: 1;
      z-index: 10;
      text-align: center;
      font-size: 25px;
      
    }
  }
}

.jjimg {
  display: block;
  width: 1166px;
  height: 265px;
  position: relative;
  top: -80px;
  margin: 0 auto;
  transition: transform 0.3s ease;

  // box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.3);
}

.jjimg:hover {
  transform: scale(1.1);
}

.logo {
  display: inline-block;
  width: 50px;
  height: 50px;
  padding: 5px 0 0 40px;
}

::v-deep .is-active {
  border-bottom: none !important;
  background-color: none !important;
  background-color: transparent !important;
}

::v-deep .el-menu-item {
  background-color: none !important;
  position: relative !important;
  // transition: all 0.3s ease !important;
}

::v-deep .el-menu-item:hover {
  border-bottom: none !important;
  background-color: none !important;
  background-color: transparent !important;

  // border-bottom: 2px solid #ccc !important;
}


::v-deep .el-menu-item:hover::after {
  content:"";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2.5px;
  background-color: white;
  /* 设置下划线的颜色 */
  transition: 100% 0.5s ease;

}

::v-deep .el-menu-item:hover::after {
  width: 100%;

  /* 下划线宽度为 100% 时，表示滑动到最右边 */
}

.number {
  font-size: 35px;
}

.el-menu-demo {
  // width: 60%;
  position: absolute;
  right: 50px;
  margin: 10px auto;
  display: flex;
  // margin-left: 24%;
  justify-content: space-around;
  border-bottom: none !important;
  border:none;
  // text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  .el-menu-item {
    font-size: 23px !important;
    // font-weight: bold;
  }
  .el-menu-demo:hover{
    background: none !important;
    z-index: 9999;
  }

  .el-submenu {
    .el-submenu__title {
      font-size: 23px !important;
      // font-weight: bold;
    }
  }
}

header {
  img {
    padding-top: 19px;
    padding-left: 146px;
  }
}

header .el-button {
  height: 80px;
  font-size: 15px;
  // line-height: 10px;
  margin-right: 20px;
  margin-top: 10px;
}

ul,
li {
  list-style: none;
}

::v-deep .el-carousel__container {
  height: 671px !important;
  // position: absolute;
  // top: 671px;
}
.imgs{
  display: block;
  width: 100% !important;
  height: 300px;
}
.banner {
  position: relative;
  // width: 100%;

  .el-carousel {
    width: 100%;

    /* 设置 carousel 宽度为 100% */
  }

  .carousel-item-content {
    width: 100%;
    display: block;
    height: auto;
    position: relative;
    // position: absolute;
    /* 设置 carousel item 内容样式，如果需要的话 */
    /* 一般情况下不需要特别设置高度，因为它会自适应内容 */
  }

  .carousel-item-content img {
    // width: 100%;
    // margin:0  auto;
    // display: block;
    // height: auto;
    // position: relative;
    /* 设置图片宽度为 100% */
    // height: auto;
    /* 图片高度自动调整，以保持宽高比 */

    /* 设置图片的最大宽度为 100%，防止图片过大 */
    max-width: 100%;
    // min-width: 100%;
    // width: 100%;
    /* 高度自动，保持原始的宽高比 */
    height: auto;

    /* 确保图片始终填满其容器，同时保持宽高比 */
    object-fit: contain;
    // object-fit: cover;
    /* 响应式图片，根据容器大小调整 */
    // display: block;

    /* 可选：如果图片需要居中显示 */
    // margin-left: auto;
    // margin-right: auto;
  }

  .bannertext {
    width: 100%;
    height: 120px;
    position: absolute;

    opacity: 1;
    bottom: 0px;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    // backdrop-filter: blur(5px);

    ul {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 0px;
      gap: 32px;

      li {
        /* 自动布局子元素 */
        position: static;
        left: 0px;
        top: 0px;
        width: 310px;
        height: 120px;
        opacity: 1;
        color: #ead08a;
        z-index: 0;
        font-size: 20px;

        .textnum {
          position: absolute;
          top: 14px;
          margin-left: -75px;
          text-align: center;
          font-size: 22px;
        }

        p {
          font-size: 30px;
          font-weight: 500;
          margin-top: 53px;
          // margin-left: 120px;
        }
      }
    }
  }
}

content {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-top: 10px;

  .homepage {
    width: 100%;
    height: 100%;

    .brief {
      /* 组 26 */

      // position: absolute;
      // width: 100%;
      height: 398px;
      opacity: 1;
      display: flex;
      // padding: 0 292px 0 292px;
      // position: relative;

      img {
        display: block;
        width: 691;
        height: auto;
        z-index: 9;
      }

      .briefdiv {
        width: 645px;
        // width: 35%;
        height: 398px;
        background: #f1f1f1;
        text-align: left;
        // position: absolute;
        // right: 30px;

        .comp {
          display: block;
          width: 292px;
          height: 18px;
          margin-top: 16px;
          margin-left: 40px;
          z-index: 99;
        }

        b {
          display: block;
          margin-left: 40px;
          margin-top: 10px;
          font-size: 26px;
          color: #c49958;
        }

        p {
          text-indent: 2em;

          margin-top: 20px;
          margin: 15px auto;
          width: 80%;
          // margin-left: 60px;
          height: 120px;
          opacity: 1;
          font-family: Source Han Sans;
          font-size: 18px;
          font-weight: normal;
          // line-height: 30px;
          text-align: justify;
        }
      }
    }

    .product {
      margin-top: 10px;
      width: 100%;
      height: 146px;
      background: #f9f9f9;
      margin: 0 auto;

      .proctext {
        width: 1336px;
        background: #f9f9f9;
        text-align: left;
        margin: 20px auto;
        // padding-left: 290px;

        h1 {
          color: #c49958;
          padding-top: 20px;
        }

        img {
          margin-top: 15px;
        }
      }

      .productbox {
        width: 1356px;
        // height: 398px;
        margin-top: 50px;
        margin: 50px auto;
        position: relative;
        overflow: hidden;

        .blockbtn {
          position: absolute;
          bottom: 50px;
          // width: 23%;
          right: 80px;
          z-index: 99;
          display: flex;

          button {
            width: 100px;
            height: 50px;
            border-radius: 5px;
            border: none;
            margin-left: 10px;

            img {
              margin-top: 0px;
            }
          }
        }
      }
    }

    .state {
      margin-top: 550px;
      width: 100%;
      height: 146px;
      background: #f9f9f9;
      text-align: left;

      // padding-left: 290px;
      .statetext {
        width: 1336px;
        background: #f9f9f9;
        text-align: left;
        margin: 20px auto;

        h1 {
          color: #c49958;
          padding-top: 20px;
          // padding-left: 290px;
        }

        .stateimg {
          margin-top: 15px;
          // padding-left: 290px;
        }
      }

      .statebox {
        width: 100%;
        margin: 45px auto;

        ul {
          display: flex;
          // width: 1080px;
          width: 1336px;
          height: auto;
          margin: 0 auto;
          text-align: center;

          // justify-content: space-around;
          li:hover {
            overflow: hidden;
            transform: scale(1.08);
          }

          li {
            // flex: 1;
            border-radius: 10px;
            width: 410px;
            height: 600px;
            margin-left: 30px;
            margin: 0 auto;
            // border: 1px solid #ccc;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
            position: relative;
            overflow: hidden;
            transform: scale(1);
            transition: transform 0.3s ease;

            img {
              transform: scale(1);
              transition: transform 0.3s ease;
              margin-top: 0;
             
            }

            img:hover {
              transform: scale(1.08);
            }

            h2 {
              transform: scale(1);
              transition: transform 0.3s ease;
              padding: 15px;
            }

            h2:hover {
              transform: scale(1.08);
            }

            span {
              transform: scale(1);
              transition: transform 0.3s ease;
              display: block;
              padding: 0px 18px 18px 18px;
            }

            span:hover {
              transform: scale(1.08);
            }

            button {
              position: absolute;
              right: 0;
              border: none;
              width: 50px;
              height: 50px;
              bottom: 20px;
              right: 20px;
            }
          }
        }
      }
    }

    .strategic {
      margin-top: 618px;
      width: 100%;
      height: 146px;
      background: #f9f9f9;
      text-align: left;

      // padding-left: 290px;
      .strategictext {
        width: 1336px;
        margin: 20px auto;

        h1 {
          color: #c49958;
          padding-top: 20px;
          // padding-left: 290px;
        }

        .stateimg {
          margin-top: 15px;
          // padding-left: 290px;
        }
      }

      .statebox {
        width: 100%;
        margin-top: 45px;

        ul {
          display: flex;
          // width: 73%;
          margin: 0 auto;
          justify-content: space-around;

          li {
            width: 1336px;

            img {
              display: block;
              width: 100%;
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}

footer {
  width: 100%;
  height: 305px;
  background: #C49958;
  opacity: 0.8;
  // position: fixed;
  // bottom: 0;

  p {
    color: #7b5722;
    margin-top: 10px;
  }
}

.contact {
  width: 70px;
  height: 70px;
  // background-color: aquamarine;
  position: fixed;
  right: 0;
  top: 44%;
  z-index: 999;

  li {
    width: 50px;
    height: 50px;
    margin-top: 20px;
    cursor: pointer;
    // border-bottom: 1px solid #ccc;
  }
}
</style>
<style lang="scss">
.el-menu--popup {
  width: 113px !important;
  min-width: 113px !important;
  background-color: #ccc;
  margin-top: 10px;
}

.el-submenu__title {
  font-size: 25px !important;
  // font-weight: bold;
}

.el-carousel__indicators {
  display: none;
}

// .el-carousel__arrow {
//     display: none !important;
// }
</style>